'use client'
import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { UnprocessableEntityErrorCode } from '@dynamic-labs/sdk-api-core';
import '@dynamic-labs/utils';
import '../../../components/Accordion/components/AccordionItem/AccordionItem.js';
import '@dynamic-labs/iconic';
import { useViewContext } from '../../../context/ViewContext/ViewContext.js';
import '../../../shared/logger.js';
import '@dynamic-labs/wallet-connector-core';
import '@dynamic-labs/wallet-book';
import '../../constants/colors.js';
import '../../constants/values.js';
import '../../../shared/consts/index.js';
import '../../../components/Alert/Alert.js';
import '../../../events/dynamicEvents.js';
import '../../../context/DynamicContext/DynamicContext.js';
import '../../../store/state/loadingAndLifecycle/loadingAndLifecycle.js';
import '../../../store/state/authMode/authMode.js';
import { useInternalDynamicContext } from '../../../context/DynamicContext/useDynamicContext/useInternalDynamicContext/useInternalDynamicContext.js';
import '../../../context/CaptchaContext/CaptchaContext.js';
import '../../../context/ErrorContext/ErrorContext.js';
import '@dynamic-labs/multi-wallet';
import 'react-international-phone';
import '../../../store/state/nonce/nonce.js';
import '@dynamic-labs-sdk/client/core';
import '@dynamic-labs-sdk/client';
import '../../../client/client.js';
import '../../../store/state/projectSettings/projectSettings.js';
import '../../../config/ApiEndpoint.js';
import '../../../locale/locale.js';
import '../../../store/state/dynamicContextProps/dynamicContextProps.js';
import '../../../store/state/primaryWalletId/primaryWalletId.js';
import '../../../store/state/connectedWalletsInfo/connectedWalletsInfo.js';
import '../../../context/AccessDeniedContext/AccessDeniedContext.js';
import '../../../context/AccountExistsContext/AccountExistsContext.js';
import '../../../context/UserWalletsContext/UserWalletsContext.js';
import '../../../context/VerificationContext/VerificationContext.js';
import 'react-dom';
import '../../functions/compareChains/compareChains.js';
import '../../../views/Passkey/utils/findPrimaryEmbeddedChain/findPrimaryEmbeddedChain.js';
import '../../../context/ThemeContext/ThemeContext.js';
import '../useUserUpdateRequest/useUpdateUser/userFieldsSchema.js';
import 'bs58';
import '@dynamic-labs/types';
import '../../../context/SocialRedirectContext/SocialRedirectContext.js';
import '../../../context/LoadingContext/LoadingContext.js';
import '../../../context/WalletContext/WalletContext.js';
import '../useEmbeddedWallet/useSecureEnclaveEmbeddedWallet/constants.js';
import 'yup';
import '../../../context/MockContext/MockContext.js';
import '../../../views/CollectUserDataView/useFields.js';
import '../../../context/FieldsStateContext/FieldsStateContext.js';
import '../../../context/UserFieldEditorContext/UserFieldEditorContext.js';
import '@dynamic-labs/rpc-providers';
import '../../../store/state/walletOptions/walletOptions.js';
import { Typography } from '../../../components/Typography/Typography.js';
import '../../../context/FooterAnimationContext/index.js';
import '../../../components/ShadowDOM/ShadowDOM.js';
import '../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../components/OverlayCardBase/OverlayCardTarget/OverlayCardTarget.js';
import '../../../context/WalletGroupContext/WalletGroupContext.js';
import '../../../widgets/DynamicWidget/components/DynamicWidgetHeader/DynamicWidgetHeader.js';
import 'react-focus-lock';
import { useWidgetContext } from '../../../widgets/DynamicWidget/context/DynamicWidgetContext.js';
import '../../../components/IconButton/IconButton.js';
import '../../../components/MenuList/Dropdown/Dropdown.js';
import 'formik';
import '../useSubdomainCheck/useSubdomainCheck.js';
import '../../../store/state/sendBalances.js';
import '../../../components/Input/Input.js';
import '../../../components/OverlayCard/OverlayCard.js';
import '../../../views/TransactionConfirmationView/TransactionConfirmationView.js';
import '../../../context/PasskeyContext/PasskeyContext.js';
import '../../../widgets/DynamicWidget/views/ManagePasskeysWidgetView/PasskeyCard/PasskeyCard.js';
import '../../../context/OnrampContext/OnrampContext.js';
import '../../../widgets/DynamicWidget/helpers/convertExchangeKeyAndProviderEnum.js';
import 'qrcode';
import '../../../widgets/DynamicWidget/views/ReceiveWalletFunds/ReceiveWalletFunds.js';
import '../../../../index.js';
import '../../../context/IpConfigurationContext/IpConfigurationContext.js';
import '../../../context/ConnectWithOtpContext/ConnectWithOtpContext.js';
import '../../../widgets/DynamicBridgeWidget/views/WalletsView/components/SecondaryWallets/SecondaryWallets.js';
import '@hcaptcha/react-hcaptcha';
import '../../../context/ErrorContext/hooks/useErrorText/useErrorText.js';
import '../../../components/PasskeyCreatedSuccessBanner/PasskeyCreatedSuccessBanner.js';
import '../../../store/state/connectorsInitializing/connectorsInitializing.js';
import '../../../store/state/tokenBalances.js';
import '../../../shared/utils/functions/getInitialUrl/getInitialUrl.js';
import { useExchangeAccounts } from '../useExchangeAccounts/useExchangeAccounts.js';
import '../../../components/InlineWidget/InlineWidget.js';
import '../../../components/IsBrowser/IsBrowser.js';
import '../../../components/Popper/Popper/Popper.js';
import '../../../components/Popper/PopperContext/PopperContext.js';

const useSubmitExchangeFunding = () => {
    const { exchangeTransfer } = useExchangeAccounts();
    const { setDynamicWidgetView, goToInitialDynamicWidgetView, setHeaderAlert } = useWidgetContext();
    const { clearStackAndPush } = useViewContext();
    const { primaryWallet, setShowAuthFlow } = useInternalDynamicContext();
    const { t } = useTranslation();
    const submit = useCallback((_a) => __awaiter(void 0, [_a], void 0, function* ({ tokenAmount, exchange, tokenSymbol, mfaCode, toAddress, props, }) {
        if (!tokenAmount)
            return;
        try {
            const result = yield exchangeTransfer({
                exchange,
                transferRequest: Object.assign({ amount: parseInt(tokenAmount, 10), currency: tokenSymbol, to: toAddress }, (mfaCode ? { mfaCode } : {})),
            });
            setShowAuthFlow(false);
            setDynamicWidgetView('deposited-exchange', {
                onClose: goToInitialDynamicWidgetView,
                onSubmit: goToInitialDynamicWidgetView,
                toAddress,
                transaction: result,
            });
        }
        catch (error) {
            let errorMessage = '';
            let showError = false;
            if (error.code ===
                UnprocessableEntityErrorCode.TransferMfaRequired) {
                setShowAuthFlow(true);
                clearStackAndPush('mfa-exchange-view', {
                    onBack: () => {
                        setShowAuthFlow(false);
                        setDynamicWidgetView('confirm-exchange-transfer', Object.assign({}, props));
                    },
                    onSubmit: (code) => {
                        submit({
                            exchange,
                            mfaCode: code,
                            props,
                            toAddress,
                            tokenAmount,
                            tokenSymbol,
                        });
                    },
                });
            }
            else if (error.code ===
                UnprocessableEntityErrorCode.TransferMfaFailed) {
                showError = true;
                errorMessage = t('dyn_exchange_transfer_errors.mfa_failed');
            }
            else if (error.code ===
                UnprocessableEntityErrorCode.InvalidTransferCurrency) {
                showError = true;
                errorMessage = t('dyn_exchange_transfer_errors.invalid_currency_description');
            }
            else if (error.code ===
                UnprocessableEntityErrorCode.InvalidTransferFunds) {
                showError = true;
                errorMessage = t('dyn_exchange_transfer_errors.invalid_balance');
            }
            else {
                showError = true;
                errorMessage = t('dyn_exchange_transfer_errors.unknown');
            }
            if (showError) {
                const errorAlert = (jsxs(Typography, { variant: 'body_normal', color: 'current-color', copykey: 'dyn_exchange_transfer_errors.title', children: [t('dyn_exchange_transfer_errors.title'), jsx(Typography, { color: 'current-color', children: errorMessage })] }));
                setShowAuthFlow(false);
                goToInitialDynamicWidgetView();
                setHeaderAlert({
                    content: errorAlert,
                    variant: 'error',
                });
            }
        }
    }), [
        clearStackAndPush,
        exchangeTransfer,
        goToInitialDynamicWidgetView,
        primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector,
        setDynamicWidgetView,
        setHeaderAlert,
        setShowAuthFlow,
        t,
    ]);
    return submit;
};

export { useSubmitExchangeFunding };
